const Component = () => import('./MemberDeals');

// eslint-disable-next-line import/prefer-default-export
export { Component };
